import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import { fetchJson } from '@atlassian/jira-fetch';
import type { ConfluenceLinkClaim, ConfluenceLink } from '../../types';
import { wrmClaimSafe } from '../../utils/get-wrm-claim';
import {
	fetchAppLinkNoEyeball,
	fetchCurrentAppLinkNoEyeball,
	fetchCurrentAppLinkNoEyeballV2,
} from '../rest/confluence/app-link';

export const fetchConfluenceAppLinks = (projectKey: string) => fetchAppLinkNoEyeball(projectKey);

export const fetchSystemAppLink = (projectKey: string) =>
	fetchAppLinkNoEyeball(projectKey).map((data) => data.appLinks.find((link) => link.isSystem));

export const fetchCurrentAppLink = (projectKey: string) => fetchCurrentAppLinkNoEyeball(projectKey);
export const fetchCurrentAppLinkV2 = (projectKey: string) =>
	fetchCurrentAppLinkNoEyeballV2(projectKey);

export const fetchConfluenceLink = (projectKey: string): Observable<ConfluenceLink> => {
	const kbLink: ConfluenceLinkClaim = wrmClaimSafe('sd-kb-link');
	if (kbLink) {
		// @ts-expect-error - TS2339 - Property 'error' does not exist on type 'ConfluenceLink | ConfluenceLinkError'.
		if (kbLink && !kbLink.error) {
			return Observable.of({
				projectKey,
				// @ts-expect-error - TS2339 - Property 'id' does not exist on type 'ConfluenceLink | ConfluenceLinkError'.
				id: kbLink.id,
				// @ts-expect-error - TS2339 - Property 'spaceKey' does not exist on type 'ConfluenceLink | ConfluenceLinkError'.
				spaceKey: kbLink.spaceKey,
				// This is the base URL of the KB instance, not Jira
				/* eslint-disable-next-line jira/deprecations/no-base-url */ // @ts-expect-error - TS2339 - Property 'baseUrl' does not exist on type 'ConfluenceLink | ConfluenceLinkError'.
				baseUrl: kbLink.baseUrl,
			});
		}

		// @ts-expect-error - TS2339 - Property 'error' does not exist on type 'ConfluenceLink | ConfluenceLinkError'.
		if (kbLink && kbLink.error) {
			return Observable.throw(kbLink);
		}
	}

	return Observable.throw({
		error: {
			key: 'sd.applinks.error.corrupt',
		},
	});
};

const ERROR_KEY_MAP = {
	'404': 'sd.kb.link.error.link.not.found',
	other: 'sd.applinks.error.corrupt',
} as const;

export const fetchConfluenceLinkRestful = (projectKey: string): Promise<ConfluenceLink> => {
	const url = `/rest/servicedesk/1/pages/agent/knowledge/${projectKey}`;
	return fetchJson(url).catch((err) =>
		// eslint-disable-next-line prefer-promise-reject-errors
		Promise.reject({
			error: {
				// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ readonly '404': "sd.kb.link.error.link.not.found"; readonly other: "sd.applinks.error.corrupt"; }'.
				key: ERROR_KEY_MAP[err.statusCode] || ERROR_KEY_MAP.other,
			},
		}),
	);
};
